import {connect} from 'react-redux';

import {ContactsManagerCreateContactFormState} from '../../../../../../../src/store/panels/contacts/contactsManager/sidePanel/contactsManagerCreateContactFormState';
import {closeSidePanelAction} from '../../../../../../../src/store/panels/contacts/contactsManager/sidePanel/contactsManagerSidePanelActions';
import {createContactFormCreateContactAsyncAction} from '../../../../../../../src/store/panels/contacts/createContactForm/createContactFormActions';
import {ContactsManagerPanelId} from '../../../../../../../src/store/panels/panelStateBase';
import {makeMapDispatchToProps} from '../../../../../../../srcCommon/helpers/reselectHelpers';
import {CreateContactFooter} from './createContactFooter';

/*
 * Props.
 */

interface CreateContactFooterContainerProps {
  panelId: ContactsManagerPanelId;
  createContactFormState: ContactsManagerCreateContactFormState;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<CreateContactFooterContainerProps>()((props) => ({
  closeSidePanel: closeSidePanelAction,
  createCardAsync: createContactFormCreateContactAsyncAction,
}));

export const CreateContactFooterContainer = connect(null, mapDispatchToProps)(CreateContactFooter);
